import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: 'page-not-found.component.html',
  styles: [`
  `]
})
export class PageNotFoundComponent {}
